import { DataTableColumnHeader } from "@/shared/components/table";
import { Checkbox } from "@/shared/components/ui/checkbox";
import type { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";
import type { TmsAccountRow } from "../types/tokens-types";

export function useTmsTokenColumns() {
    return useMemo<ColumnDef<TmsAccountRow>[]>(
        () => [
            {
                id: "select",
                header: ({ table }) => (
                    <Checkbox
                        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && "indeterminate")}
                        onCheckedChange={(v) => table.toggleAllPageRowsSelected(!!v)}
                        aria-label="Select all"
                    />
                ),
                cell: ({ row }) => (
                    <Checkbox
                        checked={row.getIsSelected()}
                        onCheckedChange={(v) => row.toggleSelected(!!v)}
                        aria-label="Select row"
                        onClick={(e) => e.stopPropagation()}
                    />
                ),
                size: 50,
                minSize: 50,
                maxSize: 50,
                enableSorting: false,
                enableHiding: false,
                enableResizing: false,
            },
            { accessorKey: "accountId", header: ({ column }) => <DataTableColumnHeader column={column} title="ID" /> },
            { accessorKey: "channel", header: ({ column }) => <DataTableColumnHeader column={column} title="채널" /> },
            { accessorKey: "appId", header: ({ column }) => <DataTableColumnHeader column={column} title="앱(클라이언트) ID" /> },
            { accessorKey: "userId", header: ({ column }) => <DataTableColumnHeader column={column} title="사용자 ID" /> },
            { accessorKey: "createdAt", header: ({ column }) => <DataTableColumnHeader column={column} title="생성 시각" /> },
            { accessorKey: "updatedAt", header: ({ column }) => <DataTableColumnHeader column={column} title="업데이트 시각" /> },
            { accessorKey: "usedAt", header: ({ column }) => <DataTableColumnHeader column={column} title="최종 사용 시각" /> },
            { accessorKey: "status", header: ({ column }) => <DataTableColumnHeader column={column} title="상태" /> },
        ],
        []
    );
}